var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconLabelRolls = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M23.69 15.73c2.62 0 4.55-1.12 4.55-2.62s-1.97-2.62-4.55-2.62c-2.62-.04-4.55 1.07-4.55 2.57s1.93 2.66 4.55 2.66Zm0-3.73c1.89 0 3.05.73 3.05 1.12s-1.16 1.12-3.05 1.12-3.05-.73-3.05-1.12c0-.43 1.16-1.12 3.05-1.12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M23.69 5.14c-8.58 0-15.31 3.47-15.31 7.93v6.43H1.77c-.43 0-.77.34-.77.77v13.81c0 .43.34.77.77.77h21.92c11.58 0 15.31-5.23 15.31-7.76V13.07c0-4.46-6.73-7.93-15.31-7.93Zm0 1.54c7.46 0 13.81 2.96 13.81 6.43s-6.3 6.43-13.81 6.43-13.81-2.96-13.81-6.43c0-3.52 6.35-6.43 13.81-6.43Zm-3.13 14.37v12.31H11.9V21.05h8.66ZM9.88 16.59c1.07 1.16 2.7 2.19 4.67 2.92H9.88v-2.92Zm-7.33 4.46h7.85v12.31H2.54V21.05Zm19.51 12.27V21.05h1.63c2.57 0 4.93-.3 7.03-.86V32.5c-1.89.51-4.2.86-7.03.86h-1.63v-.04ZM37.5 27.1c0 1.07-1.37 3.35-5.23 4.85V19.73c2.23-.77 4.03-1.84 5.23-3.13v10.51Z"
  })));
};
export default SvgIconLabelRolls;